import { Button, CircularProgress, Tooltip } from '@mui/material';

import type { StagedChangesPillButton } from './StagedChangesPill.types';
import { borderRadius } from '../../tokens/core/border-radius/border-radius';

/**
 * One of `StagedChangesPill`'s two actions. `loading` implies disabled, and takes
 * the `startIcon` slot — MUI 6's `Button` has no `loading` of its own.
 */
export const PillButton = ({
  button,
  variant,
}: {
  button: StagedChangesPillButton;
  variant: 'outlined' | 'contained';
}) => {
  const control = (
    <Button
      variant={variant}
      size="medium"
      color="primary"
      disabled={button.disabled || button.loading}
      onClick={button.onClick}
      data-testid={button['data-testid']}
      startIcon={
        // `inherit` so the spinner greys out with the disabled label.
        button.loading ? <CircularProgress size={16} color="inherit" /> : button.startIcon
      }
      sx={{ borderRadius: `${borderRadius.full}px`, textTransform: 'none' }}
    >
      {button.label}
    </Button>
  );
  if (!button.tooltip) return control;
  // A disabled button fires no pointer events, so the tooltip listens on the
  // wrapper instead — which is the case that needs a tooltip most.
  return (
    <Tooltip title={button.tooltip} arrow>
      <span>{control}</span>
    </Tooltip>
  );
};
